var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.notes),function(note,index){return [_c('p',{key:index,domProps:{"innerHTML":_vm._s(note.note)}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }